// extracted by mini-css-extract-plugin
export default {"payment-footer__container":"payment-footer__container--11mJr","payment-footer__items":"payment-footer__items--35v9l","payment-footer__message":"payment-footer__message--3nfJc","payment-footer__accepted-methods":"payment-footer__accepted-methods--95xK2"};
    if(module.hot) {
      // 1747648141418
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  